// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz

(() => {
  const LAGRING_SAMLING = 'sm-senaste-samling';
  const LAGRING_AGARE = 'sm-senaste-agare';
  const html = document.documentElement;
  const sidtyp = html.dataset.sidtyp || '';
  const franSida = html.dataset.samlingUrl || '';
  const designlage = html.classList.contains('shopify-design-mode');

  const tillSokvag = (url) => {
    try {
      return new URL(url, window.location.origin).pathname.replace(/\/$/, '') || '/';
    } catch {
      return String(url || '/').replace(/\/$/, '') || '/';
    }
  };

  const arKatalogAlla = (sokvag) => /\/collections\/all$/.test(sokvag);
  const arKollektionsindex = (sokvag) => /\/collections$/.test(sokvag);
  const arSok = (sokvag) => sidtyp === 'search' || /\/search$/.test(sokvag);
  const arHem = (sokvag) => sokvag === '/' || sokvag === tillSokvag(html.dataset.rotUrl || '/');

  const las = () => {
    try {
      return {
        url: sessionStorage.getItem(LAGRING_SAMLING) || '',
        agare: sessionStorage.getItem(LAGRING_AGARE) || '',
      };
    } catch {
      return { url: '', agare: '' };
    }
  };

  const skriv = (url, agare) => {
    try {
      if (url && !arKatalogAlla(tillSokvag(url))) sessionStorage.setItem(LAGRING_SAMLING, url);
      if (agare) sessionStorage.setItem(LAGRING_AGARE, agare);
    } catch {
      // Privat läge kan blockera lagring.
    }
  };

  const sparad = las();
  const sokvag = tillSokvag(window.location.pathname);

  if (franSida && !arKatalogAlla(tillSokvag(franSida))) {
    if (sparad.url && tillSokvag(sparad.url) !== tillSokvag(franSida) && !designlage) {
      window.location.replace(sparad.url);
      return;
    }
    if (!sparad.url) skriv(franSida, '');
  }

  const o = (!arKatalogAlla(tillSokvag(franSida)) && franSida) || las().url;
  if (!o) return;

  const oSokvag = tillSokvag(o);
  const skaTillbaka =
    arHem(sokvag) ||
    arKollektionsindex(sokvag) ||
    arKatalogAlla(sokvag) ||
    arSok(sokvag);

  if (!designlage && skaTillbaka && sokvag !== oSokvag) {
    window.location.replace(o);
    return;
  }

  const verkstall = () => {
    if (sidtyp === 'collection' && franSida) {
      const agareText = document.querySelector('.toppstapel__cell--mitten .toppstapel__text');
      skriv(franSida, agareText?.textContent.trim() || '');
    }

    const { agare } = las();
    const mitten = document.querySelector('.toppstapel__cell--mitten');
    if (mitten instanceof HTMLAnchorElement) {
      mitten.href = o;
      if (agare) {
        const text = mitten.querySelector('.toppstapel__text');
        if (text) text.textContent = agare;
      }
    }

    document.querySelectorAll('[data-action~="tillbaka/samling"]').forEach((nod) => {
      if (nod instanceof HTMLAnchorElement) nod.href = o;
    });

    document.querySelectorAll('a[href]').forEach((nod) => {
      if (!(nod instanceof HTMLAnchorElement)) return;
      const hrefSokvag = tillSokvag(nod.getAttribute('href') || '');
      if (arKatalogAlla(hrefSokvag) || arKollektionsindex(hrefSokvag) || arSok(hrefSokvag)) {
        nod.href = o;
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', verkstall);
  } else {
    verkstall();
  }
})();
